import { render } from "./EditEventBS.vue?vue&type=template&id=6646be48&scoped=true"
import script from "./EditEventBS.vue?vue&type=script&lang=js"
export * from "./EditEventBS.vue?vue&type=script&lang=js"

import "./EditEventBS.vue?vue&type=style&index=0&id=6646be48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6646be48"]])

export default __exports__